import React, { Component } from "react";
import { Editor, EditorState, convertToRaw, convertFromRaw, RichUtils } from "draft-js";
import 'draft-js/dist/Draft.css';
import { addRanking } from "../../../../stores/actions/rankingAction";
import { connect } from "react-redux";

class NewQuestionnaireRanking extends Component {
    constructor(props) {
        super(props);
        this.selectRef = React.createRef();
        this.state = {
            title: '',
            selectedSchemes: [],
            action: '',
            description: '',
            maxPercentage: '',
            minPercentage: '',

            getRankingAction: EditorState.createEmpty(),

            isLoading: null
        }
        this.baseState = this.state;
    }

    componentDidMount(){
        if(this.props.onMountRegister){
            this.props.onMountRegister(this.resetState);
        }
    }
    componentDidUpdate = (prevProps, prevState) => {
        const { addRankingError, addRankingSuccess } = this.props;

        if (prevProps.addRankingError !== addRankingError) {
            this.setState({
                isLoading: false,
                message: {
                    msg: addRankingError.message,
                    type: addRankingError.type
                }
            })
        }

        if (prevProps.addRankingSuccess !== addRankingSuccess) {
            window.alert('Ranking added successfully');
            this.setState({
                isLoading: false,
                message: {
                    msg: addRankingSuccess.message,
                    type: addRankingSuccess.type
                } 
            })
            setTimeout(() => {
                this.setState(this.baseState);
                this.props.hideRankingModalAdd();
            }, 500)
        }
    }

    handleSchemeSelection = (event) => {
        const { schemes } = this.props;
        const selectedSchemeId = event.target.value;

        const selectedScheme = schemes.find(scheme => scheme.id === selectedSchemeId);//returns the data from schemes props with the same id as selectedSchemeId

        if (!selectedScheme) return;//return nothing if nothing matches

        const schemeSubset = {//filter the data to show only these 3 key value pair
            id: selectedScheme.id,
            name: selectedScheme.name,
            code: selectedScheme.code
        };

        this.setState(prevState => ({
            selectedSchemes: [...prevState.selectedSchemes, schemeSubset]//return previous state along with new data
        }), () => {
            this.selectRef.current.value = "";
        })
    }

    handleSelectedSchemeDelete = (selectedSchemeId) => {
        this.setState(prevState => ({
            selectedSchemes: prevState.selectedSchemes.filter(selectedScheme => selectedScheme.id !== selectedSchemeId)
        }))
    }

    onDescriptionChange = (getRankingAction) => {
        this.setState({ getRankingAction });
    }

    _onBoldClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'BOLD'));
    }

    _onItalicClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'ITALIC'));
    }

    _onUnderlineClick = (editorState, changeHandler) => {
        changeHandler(RichUtils.toggleInlineStyle(editorState, 'UNDERLINE'));
    }

    handleKeyCommand = (command, editorState, changeHandler) => {
        const newState = RichUtils.handleKeyCommand(editorState, command);
        if (newState) {
            changeHandler(newState);
            return 'handled';
        }
        return 'not-handled';
    }

    handleAddAction = () => {//convert Draftjs ContentState object to raw JS structure before saving inside firebase
        const { getRankingAction } = this.state;
        const actionRawContent = convertToRaw(getRankingAction.getCurrentContent());

        if (getRankingAction.getCurrentContent().getPlainText().trim()) {
            this.setState({
                action: actionRawContent
            })
        }
    }

    addRanking = () => {
        var result = window.confirm('Confirm Add Ranking?');
        if (result) {
            this.handleAddAction();
            this.setState({
                isLoading: true,
            }, () => {
                this.props.addRanking(this.state);
            });
        }
    }

    resetState = () => {
        this.setState({
            title: '',
            selectedSchemes: [],
            action: '',
            description: '',
            maxPercentage: '',
            minPercentage: '',

            getRankingAction: EditorState.createEmpty(),
        })
    }

    render() {

        const { schemes } = this.props;
        const { selectedSchemes, getRankingAction,maxPercentage, minPercentage,description } = this.state;

        const availableSchemes = schemes ? schemes.filter(scheme => !selectedSchemes.some(selected => selected.id === scheme.id)) : [];
        // console.log(this.state)

        return (
            <div>
                <p>
                    <b>Title</b>
                    <input type="text" className="form-control" value={this.state.title} onChange={(event) => this.setState({ title: event.target.value })} />
                </p>
                <div>
                    <b>Select related scheme:</b>
                    <select ref={this.selectRef} className="form-control" onChange={this.handleSchemeSelection}>{/*Value yg passed is scheme.id via event.target.value*/}
                        <option value="">Choose Related Scheme&#40;s&#41;</option>
                        {availableSchemes.map(scheme => {
                            return (
                                <option value={scheme.id} key={scheme.id}>
                                    {scheme.name} &#40;{scheme.code}&#41;
                                </option>
                            )
                        })}
                    </select>

                    <b>Selected Schemes</b>
                    {selectedSchemes && selectedSchemes.map(selectedScheme => {
                        return (
                            <div key={selectedScheme.id} className="d-flex justify-content-between">
                                <div style={{ position: 'relative', left: '10px' }}>{selectedScheme.name} &#40;{selectedScheme.code}&#41;</div>
                                <span onClick={() => this.handleSelectedSchemeDelete(selectedScheme.id)}><i className="fa fa-trash text-red"></i></span>
                            </div>
                        )
                    })}
                </div>
                <div>
                    <b>Min Percentage</b>
                    <input type="number" value={minPercentage} className="form-control" onChange={(event) => this.setState({ minPercentage: event.target.value })} />
                </div>
                <div>
                    <b>Max Percentage</b>
                    <input type="number" className="form-control" value={maxPercentage} onChange={(event) => this.setState({ maxPercentage: event.target.value })} />
                </div>
                <div>
                    <b>Action</b>
                    <div style={{ backgroundColor: '#eeeeee', padding: '10px' }}>
                        <div className="col-md d-flex align-items-center justify-content-start px-0" style={{ marginBottom: '10px', paddingBottom: '5px' }}>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onBoldClick(getRankingAction, this.onDescriptionChange)}
                                style={{
                                    fontWeight: getRankingAction.getCurrentInlineStyle().has('BOLD') ? 'bold' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: this.state.getRankingAction.getCurrentInlineStyle().has('BOLD') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <strong>B</strong>
                            </button>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onItalicClick(getRankingAction, this.onDescriptionChange)}
                                style={{
                                    fontStyle: getRankingAction.getCurrentInlineStyle().has('ITALIC') ? 'italic' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: getRankingAction.getCurrentInlineStyle().has('ITALIC') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <em>I</em>
                            </button>
                            <button
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => this._onUnderlineClick(this.state.getRankingAction, this.onDescriptionChange)}
                                style={{
                                    textDecoration: getRankingAction.getCurrentInlineStyle().has('UNDERLINE') ? 'underline' : 'normal',
                                    marginRight: '5px',
                                    padding: '5px 10px',
                                    border: '1px solid #ccc',
                                    backgroundColor: getRankingAction.getCurrentInlineStyle().has('UNDERLINE') ? '#e6f3ff' : 'white',
                                    cursor: 'pointer'
                                }}
                            >
                                <u>U</u>
                            </button>
                        </div>
                        <div>
                            <div style={{ border: '1px solid #ccc', minHeight: '50px', padding: '10px', flexGrow: 1, backgroundColor: 'white' }}>
                                <Editor
                                    editorState={getRankingAction}
                                    onChange={this.onDescriptionChange}
                                    handleKeyCommand={(command) => this.handleKeyCommand(command, getRankingAction, this.onDescriptionChange)}
                                    placeholder="Action"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <b>Description</b>
                    <textarea className="form-control" value={description} onChange={(event) => this.setState({ description: event.target.value })} />
                </div>
                <div className="mt-5 row justify-content-end">
                    <button className="btn m-2 btn-outline-black" onClick={this.addRanking}><i className="fas fa-plus-circle" />{' '}Add Ranking</button>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        addRankingSuccess: state.ranking.addRankingSuccess,
        addRankingError: state.ranking.addRankingError
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addRanking: (ranking) => dispatch(addRanking(ranking)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewQuestionnaireRanking);